export enum AccordionLayout {
  OneColumn = "one-column",
  TwoColumn = "two-column",
}
